import React from 'react';
import { Field } from 'redux-form';
import { Checkbox, TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import Filters from '../../../components/Filters';

type Props = {
  handleFilter: () => void,
  handleResetFilter: () => void,
  filterValues: Object,
};

export default ({ handleFilter, handleResetFilter, filterValues }: Props) => {
  const fieldMap = {
    email: 'Email',
    name: 'Name',
    status: 'Status',
    hasStartedJobs: 'Has Started Jobs',
    hasOpenJobOffers: 'Has Open Job Offers',
  };

  return (
    <Filters
      handleFilter={handleFilter}
      handleResetFilter={handleResetFilter}
      fieldMap={fieldMap}
      values={filterValues}
    >
      <Field name="email" floatingLabelText="Email" component={TextField} />
      <br />
      <Field name="name" floatingLabelText="Name" component={TextField} />
      <br />
      <Field
        name="status"
        floatingLabelText="Status"
        component={SelectField}
        disabled
      >
        <MenuItem value="" primaryText="" />
        <MenuItem value="Active" primaryText="Active" />
        <MenuItem value="Pending" primaryText="Pending" />
        <MenuItem value="Locked" primaryText="Locked" />
      </Field>
      <br />
      <Field
        name="hasStartedJobs"
        label="Has Started Jobs"
        component={Checkbox}
      />
      <Field
        name="hasPendingJobRequests"
        label="Has Pending Job Requests"
        component={Checkbox}
      />
    </Filters>
  );
};



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentsFilter.js